import { defineAsyncComponent } from 'vue';

export const ForceActiveFilter = defineAsyncComponent(() => import('./ForceActiveFilter.vue'));
export const TableTop = defineAsyncComponent(() => import('./TableTopForceActive.vue') );

